// CommentsAdd.jsx

import React, { useState } from 'react';

// CSS
import './CommentsAdd.css';

// Components
import CommentsAddButton from './addbutton/CommentsAddButton';
import CommentsAddInput from './addinput/CommentsAddInput';

/**
 * CommentsAdd component
 *
 * Renders an add panel for comments.
 *
 *
 * @returns {ReactNode} The rendered component.
 */
const CommentsAdd = ({
    newComment,
    addButtonsVisible,
    onChange,
    onFocus,
    onAddClick,
    inputRef
}) => {

  // ----- STATE ----- //

  // State

  const [emojiSelectorVisible, setEmojiSelectorVisible] = useState(false);

  // ----- RENDER ----- //

  return (
        <div className="comments-add-container">

            {/* BUTTONS INPUT */}
            <div className="comments-add-buttons-input">
                <CommentsAddInput
                  newComment={newComment}
                  placeholder={`Add comment...`}
                  ref={inputRef}
                  emojiSelectorVisible={emojiSelectorVisible}
                  onChange={onChange}
                  onEmojiClick={(emoji) => {
                        // Handle emoji selection - this will be passed up to Comments component
                        const textarea = inputRef.current;
                        if (textarea) {
                            const start = textarea.selectionStart;
                            const end = textarea.selectionEnd;
                            const text = newComment || '';

                            const newText = text.slice(0, start) + emoji + text.slice(end);
                            onChange(newText);

                            setTimeout(() => {
                                textarea.focus();
                                const newPosition = start + emoji.length;
                                textarea.setSelectionRange(newPosition, newPosition);
                            }, 0);
                        }
                    }}
                  onFocus={onFocus}
                />
            </div>

            {/* WRAPPER */}
            <div
              className="comments-add-buttons-wrapper"
              style={{
                display: addButtonsVisible ? 'flex' : 'none',
              }}
            >
                <CommentsAddButton
                  onClick={() => onAddClick(newComment)}
                  onEmojiClick={() => setEmojiSelectorVisible(!emojiSelectorVisible)}
                />
            </div>

        </div>
    );
};

// Dev Tools
CommentsAdd.displayName = 'CommentsAdd';

export default CommentsAdd;
